/*eslint-disable */

import {
  bus
} from '@/main';
import moment from 'moment';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'msg-delete-popup',
  components: {},
  props: ['deleteMessageDataOBJ', 'roomSocketUrl'],
  data () {
    return {
      submitted:false,
      removeMsgId:'',
      checkMsgDeleteEveryOneState:false,
      selfUserId:'',
      roomId:'',
    }
  },
  computed: {

  },
  mounted () {
    document.body.classList.add('body_right_scroll_remove');
    this.removeMsgId = this.deleteMessageDataOBJ.id;
    this.roomId = this.deleteMessageDataOBJ.roomId;
    this.selfUserId = localStorage.getItem('LoginedUserID');
    if(this.deleteMessageDataOBJ.createdBy == this.selfUserId){
      this.enabledDeleteMsorEveryOneMethod(this.deleteMessageDataOBJ.time);
    }
  },
  methods: {
    enabledDeleteMsorEveryOneMethod(startTime) {
        const currentMoment = moment(); // Get the current moment once
        const startMoment = moment(startTime); // Parse the start time once
      
        // Check if the dates are the same
        if (startMoment.isSame(currentMoment, 'day')) {
            const startTotalMinutes = startMoment.hours() * 60 + startMoment.minutes();
            const currentTotalMinutes = currentMoment.hours() * 60 + currentMoment.minutes();
            const minutesDifference = currentTotalMinutes - startTotalMinutes;
            if (minutesDifference >= 0 && minutesDifference < 10) {
                this.checkMsgDeleteEveryOneState = true;
            } else {
                this.checkMsgDeleteEveryOneState = false;
            }
        } else {
            // If the dates are different, deletion is not allowed
            this.checkMsgDeleteEveryOneState = false;
        }
    },
    confirmDeleteMsgMethod(delete_for_everyone){
      this.submitted =  true;
      this.$store.dispatch('deleteMsgOfChatInWorkspaceAction',{data:{id:this.removeMsgId, query:delete_for_everyone ? 'yes' : 'no'}}).then((res) => {
        if(delete_for_everyone){
          let dateTimeAdd = [moment(this.deleteMessageDataOBJ.time).locale('en').format('h:mm a')];
          $('#chatMessageId' + this.removeMsgId + ' ' + '.dropdown').remove()        
          $('#chatMessageId' + this.removeMsgId + ' ' + 'label').remove()         
          $('#chatMessageId' + this.removeMsgId + ' ' + '.msg_in_file').remove()        
          $('#chatMessageId' + this.removeMsgId + ' ' + '.chat_in_msg_box_wrp').addClass('delete_msg_show_box')           
          $('#chatMessageId' + this.removeMsgId + ' ' + '.chat_in_msg_box_wrp').html(`<span class='chat_msg_content_show'><i aria-hidden='true' class='fa fa-ban'></i> This message was deleted</span><span class='msg_time_wrp'><time class='msg_time'>${dateTimeAdd}</time></span>`);
          this.roomSocketUrl.send(JSON.stringify({
            type: "delete_message",
            chat_room_id:this.roomId,
            message_id: this.removeMsgId
          }));
        }else{
          $('#chatMessageId' + this.removeMsgId).remove();
        }
        toast.success(res.data.msg);
        this.deleteMessagePopupDisabledFun();
        this.submitted =  false;
      }).catch((err)=>{
        this.submitted =  false;
        toast.error(err.data.msg);
      })
    },
    deleteMessagePopupDisabledFun(){
      this.checkMsgDeleteEveryOneState = false;
      document.body.classList.remove('body_right_scroll_remove');
      bus.$emit('deleteMsgPopupStateBus', false);
    }
  }
}